import Toggle from '@/components/atoms/Toggle';
import useFreeTrialHook from '@/hooks/useFreeTrialHook';

const BrandingToggle = () => {
  const { openNonBlockingPricingPaywall } = useFreeTrialHook();

  const onBrandingToggle = () => {
    openNonBlockingPricingPaywall();
  };

  return (
    <>
      <div className="col-span-2 flex items-center">
        Goldcast Branding
        <div className="ml-1 flex size-6 shrink-0 scale-[0.8] items-center justify-center rounded-lg bg-[#5449D9] text-white group-hover:bg-[#1B279B]">
          <svg
            className="size-4"
            width="100%"
            height="100%"
            viewBox="0 0 24 24"
            strokeWidth="0.5"
            stroke="currentColor"
            fill="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <path d="M13 3l0 7l6 0l-8 11l0 -7l-6 0l8 -11"></path>
          </svg>
        </div>
      </div>
      <div className="col-span-1">
        <div className="w-full rounded-md py-2 text-right focus:outline-none focus:ring-2 focus:ring-slate-950">
          <Toggle on={true} onToggle={onBrandingToggle} disabled={false} />
        </div>
      </div>
    </>
  );
};

export default BrandingToggle;
